import React from 'react';
import {ReactComponent as Icon} from 'images/icon/effectiveness/thumb-up.svg';
import {ReactComponent as IconInverted} from 'images/icon/effectiveness/thumb-up-inverted.svg';

export default function ThumbUpIcon({inverted}) {
  return inverted ? <IconInverted className="icon thumb-up" /> : <Icon className="icon thumb-up" />;
}
